import {Form,   Modal,  Row, Col,    } from 'antd'
import React, { useEffect } from 'react'
import classes from './costInvoice.module.css'
import {  useCbpdjUpdateQuery } from '../../store/DianShangYeWuApi';
import CostListWithId from '../../document/cost/CostListWithId'
import Asterisk from '../../cpn/Asterisk'   
import FilePreview from '../../cpn/FilePreview'
function CostInvoiceCheck(props) {
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'cbpdj_qy_id': '',
        'cbpdj_qy_name': '',
        'cbpdj_uid': '',
        'cbpdj_uname': '',
        'cbpdj_kh_id': '',
        'cbpdj_kh_name': '',
        'cbpdj_state': '',
        'cbpdj_image_file': '',
        'cbpdj_image_name': '',
        'cbpdj_id': '',
        'cbpdj_amount': '',
        'cbpdj_content': '',
        'cbpdj_bm_id': '',
        'cbpdj_bm_name': '',
        'cbpdj_ddzc_id': ''
    })
    const {data, isSuccess} = useCbpdjUpdateQuery({cbpdj_id:props.cbpdj_id},{skip:!open,refetchOnMountOrArgChange:1});
    const [form] = Form.useForm();
    
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            setInfo({
                'cbpdj_qy_id': data.Result.cbpdj_qy_id, 
                'cbpdj_qy_name': data.Result.cbpdj_qy_name,
                'cbpdj_uid': data.Result.cbpdj_uid,
                'cbpdj_uname': data.Result.cbpdj_uname,
                'cbpdj_ctime': data.Result.cbpdj_ctime,
                'cbpdj_kh_id': data.Result.cbpdj_kh_id,
                'cbpdj_kh_name': data.Result.cbpdj_kh_name,
                'cbpdj_state': data.Result.cbpdj_state,
                'cbpdj_image_file': data.Result.cbpdj_image_file,
                'cbpdj_image_name': data.Result.cbpdj_image_name,
                'cbpdj_id': data.Result.cbpdj_id,
                'cbpdj_amount': data.Result.cbpdj_amount,
                'cbpdj_content': data.Result.cbpdj_content,
                'cbpdj_bm_id': data.Result.cbpdj_bm_id,
                'cbpdj_bm_name': data.Result.cbpdj_bm_name,
                'cbpdj_ddzc_id': data.Result.cbpdj_ddzc_id
            });          
        }
        
    }, [data, isSuccess,form])    

    const formatCurrency = (value) => {
        if (value === null || value === undefined) return '0.00';
        return `￥${Number(value).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
     return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.cbpdj_kh_name}</a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #339900',borderLeft:'3px solid #339900'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#339900',borderTop:'3px solid #339900'}}>成本票登记</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #339900',borderRight:'3px solid #339900'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #339900',color:'#339900'}}><Asterisk color='red'/> 付款单号</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <CostListWithId
                                id={info.cbpdj_ddzc_id}
                                qy_id={props.qy_id}
                                qy_name={props.qy_name}
                                yh_id={props.yh_id}
                                yh_name={props.yh_name}
                            />
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 成本票金额</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            {formatCurrency(info.cbpdj_amount)}
                            
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #339900'}}>
                            {info.cbpdj_bm_name}
                        </Col> 
                        {/* 第二行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #339900'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            {info.cbpdj_kh_name}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 上传成本票</Col>
                        <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #339900'}}>
                            <FilePreview
                                fileNames={info.cbpdj_image_file}
                                fileUrls={info.cbpdj_image_name}
                            />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #339900',borderBottom:'3px solid #339900'}}> 备注</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #339900'}}>
                            {info.cbpdj_content}
                        </Col>
                        <Col span={2}  className={classes.col_middle_label} style={{borderBottom:'3px solid #339900'}}>提交记录</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{borderBottom:'3px solid #339900'}}>{info.cbpdj_uname} {info.cbpdj_ctime}</Col> 
                        <Col span={2} className={classes.col_middle_label} style={{borderBottom:'3px solid #339900'}}>编号</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #339900',borderBottom:'3px solid #339900'}}>
                            {info.cbpdj_id}
                        </Col>    
                                                               
                    </Row>                       
                </Form>
            </Modal>

        </>
    )
}

export default CostInvoiceCheck